export default [{
    path: 'businesslist',
    name: {list:['业务中心','会员','商家管理','商家列表','商家列表']},
    component: () => import('@/views/memberManage/business/list.vue')
},{
    path: 'businessdetail',
    name: {list:['业务中心','会员','商家管理','商家列表','商家信息详情'],title:'商家信息详情'},
    component: () => import('@/views/memberManage/business/detail.vue')
},
{
    path: 'finalValueFee',
    name: {list:['数字店铺','设置','系统配置','交易服务费']},
    component: () => import('@/views/memberManage/finalValueFee.vue')
},
{
    path: 'productList',
    name: {list:['数字店铺','商品','商品管理','商品列表']},
    component: () => import('@/views/digitalShop/productList.vue')
},
{
    path: 'agreeManage',
    name: {list:['数字店铺','设置','内容管理','协议维护']},
    component: () => import('@/views/digitalShop/agreeManage.vue')
},
{
    path: 'szdpconfigurationShare',
    name: {list:['数字店铺','运营','交易商城','商城推广']},
    component: () => import('@/views/digitalShop/configurationShare.vue')
},
{
  path: 'serchildrenlist',
  name: {list:['业务中心','服务','商家管理','服务列表']},
  component: () => import('@/views/memberManage/serveuse/childrenlist.vue')
},
{
  path: 'addchildrenserv',
  name: {list:['业务中心','服务','商家管理','服务列表'],title:'添加'},
  component: () => import('@/views/memberManage/serveuse/addchildrenserv.vue')
},
{
  path: 'serveCategory',
  name: {list:['业务中心','服务','商家管理','服务类目']},
  component: () => import('@/views/memberManage/serveuse/category.vue')
},
{
  path: 'baseList',
  name: {list:['数字基地','基地','企业基地','基地列表']},
  component: () => import('@/views/baseList/baseList.vue')
},
{
  path: 'platBaseList',
  name: {list:['数字基地','基地','平台基地','基地管理']},
  component: () => import('@/views/baseList/platBaseList.vue')
},
{
  path: 'baseDetails',
  name: {list:['数字基地','基地','平台基地','基地管理'],title:'基地详情'},
  component: () => import('@/views/baseList/baseDetails.vue')
},
{
  path: 'baseEdit',
  name: {list:['数字基地','基地','平台基地','基地管理','添加/编辑基地'],title:'添加/编辑基地'},
  component: () => import('@/views/baseList/baseEdit.vue')
},
{
  path: 'basePanel',
  name: {list:['数字基地','基地','基地面板','基地面板']},
  component: () => import('@/views/baseList/basePanel.vue')
},
{
  path: 'baseEquList',
  name: {list:['数字基地','基地','平台基地','基地设备']},
  component: () => import('@/views/baseList/baseEquList.vue')
},
{
  path: 'baseGoodsList',
  name: {list:['数字基地','基地','平台基地','基地商品']},
  component: () => import('@/views/baseList/baseGoodsList.vue')
},
{
  path: 'baseGoodsRelate',
  name: {list:['数字基地','基地','平台基地','基地商品'],title:'关联商品'},
  component: () => import('@/views/baseList/baseGoodsRelate.vue')
},
{
  path: 'xcxcode',
  name: {list:['数字种植','配置','其它配置','小程序码'],title:'小程序码'},
  component: () => import('@/views/baseList/xcxCode.vue')
},

{
  path: 'businessAuth',
  name: {list:['业务中心','用户','用户认证','商户认证']},
  component: () => import('@/views/memberManage/businessAuth/list.vue')
},
{
  path: 'businessAuthdetail',
  name: {list:['业务中心','用户','用户认证','商户认证'],title:'商家认证详情'},
  component: () => import('@/views/memberManage/businessAuth/detail.vue')
},
{
  path: 'userAuth',
  name: {list:['业务中心','用户','用户认证','个人认证']},
  component: () => import('@/views/memberManage/userAuth/list.vue')
}
,{
  path: 'userAuthdetail',
  name: {list:['业务中心','用户','用户认证','个人认证'],title:'认证详情'},
  component: () => import('@/views/memberManage/userAuth/detail.vue')
},
{
  path: 'userAuthExam',
  name: {list:['业务中心','用户','用户认证','个人认证'],title:'认证审核'},
  component: () => import('@/views/memberManage/userAuth/detail.vue')
},
{
  path: 'entpAuth',
  name: {list:['业务中心','用户','用户认证','企业认证']},
  component: () => import('@/views/memberManage/entpAuth/list.vue')
},
{
  path: 'entpAuthExam',
  name: {list:['业务中心','用户','用户认证','企业认证'],title:'认证审核'},
  component: () => import('@/views/memberManage/entpAuth/detail.vue')
},{
  path: 'entpAuthDetail',
  name: {list:['业务中心','用户','用户认证','企业认证'],title:'认证详情'},
  component: () => import('@/views/memberManage/entpAuth/detail.vue')
},{
  path: 'serveuselist',
  name: {list:['业务中心','用户','用户管理','服务权限']},
  component: () => import('@/views/memberManage/serveuse/list.vue')
},
{
    path: 'useconfigure',
    name: {list:['业务中心','用户','用户管理','服务权限'],title:'权限配置'},
    component: () => import('@/views/memberManage/serveuse/useconfigure.vue')
},
{
  path: 'userlist',
  name: {list:['业务中心','用户','用户管理','用户列表']},
  component: () => import('@/views/memberManage/userList/list.vue')
},
]